<template>
    <div  :class="'risposta-container n-' + answerData?.id" :onclick="rispostaClick" >
    <label :class="this.className">
        <span class="btn-label fs-1 mb-1">
          <i class="bi bi-caret-right"></i>
        </span> 
        <input class="btn-answer" type="radio" name="q_answer" :value="answerData.id"> <span v-html="this.text || intl[$store.state.lang][this.textId]"></span>

    </label>

    </div>
</template>

<script>
import intl from "./intl/intl";

export default {
    name: "risposta",
    mounted() {
       // console.log("ANSWERDATA: ",this.answerData)
    },
    props: {
        text: {
            type: String,
            default: null,
        },
        rispostaId: {
            type: String,
            default: null,
        },
        answerData: {
            type: Object,
            default: null
        },
        className: {
            type: String,
            default: null,
        },
        onClickCallback:  {
            type: Function,
            default: (answerData,saveLogDone) => {
                //console.log("DATI RISPOSTA: ",answerData)
                return
            },
        },
        
    },

    data: function () {
        return {
            intl: intl,
            
            
        };
    },
    methods: {
        rispostaClick(e){
            e.preventDefault()
            if(!this.answerData.disableClick){
                this.onClickCallback(this.answerData,true)
            }else{
                return null
            }
      
        }
        
    },
    watch: {
        /* name: function(newVal, oldVal) { 
          this.newName = newVal
        }, */
        
    },
    computed: {
        textId(){
            return this.rispostaId + ".text"
        }
    },
};
</script>
